// @ts-nocheck
/* eslint-disable react/prefer-stateless-function */
import React from 'react'
import UserEventEmitterContext from '../contexts/UserEventEmitterContext'
import hoistNonReactStatics from 'hoist-non-react-statics'
import forwardInnerRef from './forwardInnerRef'

const withEventEmitter = () => {
  return Component => {
    // eslint-disable-next-line react/require-render-return
    class WrappedComponent extends React.Component {
      static contextType = UserEventEmitterContext

      emitUserEvent = (eventName, payload) => {
        if (this.context) {
          const emitter = this.context
          emitter.emit(eventName, payload)
        }
      }

      render() {
        return <Component {...this.props} emitUserEvent={this.emitUserEvent} />
      }
    }

    WrappedComponent.displayName = `WithEventEmitter(${Component.displayName ||
      Component.name})`
    hoistNonReactStatics(WrappedComponent, Component)

    return forwardInnerRef(WrappedComponent)
  }
}

export default withEventEmitter
